/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Suggestion_RoomsInputs */

const en_admin_ai_chat_suggestion_rooms = /** @type {(inputs: Admin_Ai_Chat_Suggestion_RoomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What rooms are free this afternoon?`)
};

const de_admin_ai_chat_suggestion_rooms = /** @type {(inputs: Admin_Ai_Chat_Suggestion_RoomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Räume sind heute Nachmittag frei?`)
};

const es_admin_ai_chat_suggestion_rooms = /** @type {(inputs: Admin_Ai_Chat_Suggestion_RoomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué salas están libres esta tarde?`)
};

const fr_admin_ai_chat_suggestion_rooms = /** @type {(inputs: Admin_Ai_Chat_Suggestion_RoomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles salles sont libres cet après-midi ?`)
};

const nl_admin_ai_chat_suggestion_rooms = /** @type {(inputs: Admin_Ai_Chat_Suggestion_RoomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke ruimtes zijn vanmiddag vrij?`)
};

/** @type {(inputs: Admin_Ai_Chat_Suggestion_RoomsInputs) => LocalizedString} */
const it_admin_ai_chat_suggestion_rooms = en_admin_ai_chat_suggestion_rooms;

/** @type {(inputs: Admin_Ai_Chat_Suggestion_RoomsInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_suggestion_rooms = en_admin_ai_chat_suggestion_rooms;

/** @type {(inputs: Admin_Ai_Chat_Suggestion_RoomsInputs) => LocalizedString} */
const pl_admin_ai_chat_suggestion_rooms = en_admin_ai_chat_suggestion_rooms;

/** @type {(inputs: Admin_Ai_Chat_Suggestion_RoomsInputs) => LocalizedString} */
const hu_admin_ai_chat_suggestion_rooms = en_admin_ai_chat_suggestion_rooms;

/** @type {(inputs: Admin_Ai_Chat_Suggestion_RoomsInputs) => LocalizedString} */
const ro_admin_ai_chat_suggestion_rooms = en_admin_ai_chat_suggestion_rooms;

/**
* | output |
* | --- |
* | "What rooms are free this afternoon?" |
*
* @param {Admin_Ai_Chat_Suggestion_RoomsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_suggestion_rooms = /** @type {((inputs?: Admin_Ai_Chat_Suggestion_RoomsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Suggestion_RoomsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_suggestion_rooms(inputs)
	if (locale === "de") return de_admin_ai_chat_suggestion_rooms(inputs)
	if (locale === "es") return es_admin_ai_chat_suggestion_rooms(inputs)
	if (locale === "fr") return fr_admin_ai_chat_suggestion_rooms(inputs)
	if (locale === "nl") return nl_admin_ai_chat_suggestion_rooms(inputs)
	if (locale === "it") return it_admin_ai_chat_suggestion_rooms(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_suggestion_rooms(inputs)
	if (locale === "pl") return pl_admin_ai_chat_suggestion_rooms(inputs)
	if (locale === "hu") return hu_admin_ai_chat_suggestion_rooms(inputs)
	return ro_admin_ai_chat_suggestion_rooms(inputs)
});
export { admin_ai_chat_suggestion_rooms as "admin.ai_chat.suggestion_rooms" }